export class IsVisibleOnTooltipBaseValueConverter {
    toView(array) {
        return array.filter((item) => item.hasOwnProperty('IsVisibleOnTooltip') && item['IsVisibleOnTooltip'] == true);
    }
}